module.exports = __webpack_public_path__ + "img/shop.f071f52f.svg";